module.exports = __webpack_public_path__ + "static/media/service-01.e3957277.webm";